import {combineReducers} from "@reduxjs/toolkit";
import {StateType} from "typesafe-actions";
import * as reduxConstants from "./reduxConstants";
import {authReducer} from "@/features/authentication/state";
import dashboardReducer from "@/features/dashboard/dashboardSlice";
import metricDetailsReducer from "@/features/metricDetails/state/reducer";
import monitorReducer from "@/features/monitors/monitorSlice";
import {applicationReducer, ApplicationState} from "@/features/application/state";
import {type Reducer, type AnyAction} from "redux";

const appReducer: Reducer<AppState, AnyAction> = combineReducers({
    auth: authReducer,
    dashboard: dashboardReducer,
    metricDetails: metricDetailsReducer,
    application: applicationReducer,
    monitor: monitorReducer
});

export type AppState = Readonly<{
    auth: StateType<typeof authReducer>;
    dashboard: StateType<typeof dashboardReducer>;
    metricDetails: StateType<typeof metricDetailsReducer>;
    application: StateType<typeof applicationReducer>;
    monitor: StateType<typeof monitorReducer>;
}>;

// Some type magic: [0] gets the first parameter of the function type, which is the state type
// and [1] gets the second parameter, which is the action type
export type AppAction = Parameters<typeof appReducer>[1];

const rootReducer: Reducer<AppState, AppAction> = (state, action) => {
    // When signing out, preserve only auth state and legacySiteBaseUrl
    if (action.type === reduxConstants.AUTH_SIGNOUT) {
        if (state) {
            // Extract only the parts we want to keep
            const {auth} = state;
            const partialApplicationState = {
                legacySiteBaseUrl: state.application.legacySiteBaseUrl
            } as ApplicationState;

            return appReducer(
                {
                    auth,
                    application: partialApplicationState
                } as unknown as AppState,
                action
            );
        }
    }

    // For all other actions, use the normal reducer
    return appReducer(state, action);
};

export default rootReducer;
